(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fab-button"] && !Shopify.designMode) return;
  try {
    
  class FABButtonScroll {
    constructor() {
      this.fabButtons = document.querySelectorAll('.fab-button[data-scroll-down-only]');
      this.lastScrollTop = 0;
      this.scrollThreshold = 100; // Minimum scroll distance before showing
      this.init();
    }

    init() {
      if (this.fabButtons.length === 0) return;
      
      this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = scrollTop - this.lastScrollTop;
      
      this.fabButtons.forEach(button => {
        if (scrollTop > this.scrollThreshold) {
          if (scrollDelta > 0) {
            // Scrolling down
            button.classList.add('fab-button--visible');
            button.classList.remove('fab-button--scrolling-up');
          } else if (scrollDelta < 0) {
            // Scrolling up
            button.classList.remove('fab-button--visible');
            button.classList.add('fab-button--scrolling-up');
          }
        } else {
          // At top of page
          button.classList.remove('fab-button--visible', 'fab-button--scrolling-up');
        }
      });
      
      this.lastScrollTop = scrollTop;
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  // Global instance management
  window.fabButtonScroll = window.fabButtonScroll || new FABButtonScroll();

  // Shopify theme events
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.fab-button[data-scroll-down-only]')) {
      // Reinitialize if FAB button is in the loaded section
      if (window.fabButtonScroll) {
        window.fabButtonScroll.destroy();
      }
      window.fabButtonScroll = new FABButtonScroll();
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    if (event.target.querySelector('.fab-button[data-scroll-down-only]')) {
      // Clean up if FAB button is in the unloaded section
      if (window.fabButtonScroll) {
        window.fabButtonScroll.destroy();
        window.fabButtonScroll = null;
      }
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    if (event.target.querySelector('.fab-button[data-scroll-down-only]')) {
      // Ensure FAB button is visible when section is selected in theme editor
      const fabButton = event.target.querySelector('.fab-button[data-scroll-down-only]');
      if (fabButton) {
        fabButton.classList.add('fab-button--visible');
        fabButton.classList.remove('fab-button--scrolling-up');
      }
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    if (event.target.querySelector('.fab-button[data-scroll-down-only]')) {
      // Reset FAB button state when section is deselected
      const fabButton = event.target.querySelector('.fab-button[data-scroll-down-only]');
      if (fabButton) {
        fabButton.classList.remove('fab-button--visible', 'fab-button--scrolling-up');
      }
    }
  });

  // Handle theme editor block changes
  document.addEventListener('shopify:block:select', function(event) {
    if (event.target.closest('.fab-button[data-scroll-down-only]')) {
      // Ensure FAB button is visible when block is selected
      const fabButton = event.target.closest('.fab-button[data-scroll-down-only]');
      if (fabButton) {
        fabButton.classList.add('fab-button--visible');
        fabButton.classList.remove('fab-button--scrolling-up');
      }
    }
  });

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (!window.fabButtonScroll) {
        window.fabButtonScroll = new FABButtonScroll();
      }
    });
  } else {
    if (!window.fabButtonScroll) {
      window.fabButtonScroll = new FABButtonScroll();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
